export * from './src/innovation-widget-v1-message-messages.meta.js';
